import React from "react";
import { Box, Grid, InputAdornment, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import InputFields from "../../../../Components/gene20FormFields/InputFields";
import { Email, Password, Warning } from "@mui/icons-material";
const useStyles = makeStyles((theme)=>({
  inputFields:{
    position:"fixed",
    flexGrow:"1"
  }
}))

const PersonalInfo = (props) => {
  const {
    formField: { firstName, lastName, email, password },
  } = props;
  const classes=useStyles()
  return (
    <Box height="100%">
      <Grid container spacing={5}>
        <Grid item xs={12} sm={6}>
          <InputFields
            name={firstName.name}
            label={firstName.label}
            fullWidth
            

          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputFields name={lastName.name} label={lastName.label} fullWidth />
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputFields name={email.name} label={email.label} fullWidth />
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputFields
            name={password.name}
            type="password"
            label={password.label}
            fullWidth
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default PersonalInfo;

